import { TableBody } from '@mui/material'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'
import React from 'react'

import BidHistoryItem from './Row'

interface Props {
  events?: XyoWorldMinterEvents.BidPlaced[]
  page?: number
  pageSize?: number
  reverseOrder?: boolean
}

const Body: React.FC<Props> = (props) => {
  const { events, page = 0, pageSize = 20, reverseOrder = false } = props

  const startItem = page * pageSize
  const endItem = startItem + pageSize
  const eventsToRender: (XyoWorldMinterEvents.BidPlaced | null)[] = (reverseOrder ? events?.reverse() : events)?.slice(startItem, endItem) ?? []

  //pad the list
  while (pageSize && eventsToRender?.length < pageSize) {
    eventsToRender?.push(null)
  }

  return (
    <TableBody>
      {eventsToRender?.map((value, index) => {
        return <BidHistoryItem event={value} key={index} />
      })}
    </TableBody>
  )
}

export default Body
